import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Opportunity } from "../core/model/Opportunity";
import { CustomStore, createStore } from "devextreme-aspnet-data-nojquery";
import { AuthService } from "../auth/auth.service";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class OpportunityService {
  private apiUrl: string = environment.API + "/DemoInstance";
  private opprtunitySubject = new BehaviorSubject<Opportunity[]>([]);
  opportunities$ = this.opprtunitySubject.asObservable();

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}
  getOpportunitiesStore(): CustomStore {
    return createStore({
      key: "id",
      loadUrl: this.apiUrl + "/getOpportunities"
    });
  }
}
